import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';
import { ConfirmationService,ConfirmEventType } from 'primeng/api';
import {DialogModule} from 'primeng/dialog';

// declare var webengage
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  loader=false
  isNative=true
  showBackButton = true
  isIos = false
  visibleIos = false
  respwidth
  screen_width
  max_limit_monthly
  max_left_monthly
  max_limit_daily
  max_left_daily
  constructor(private http:HttpClient, public confirmationService: ConfirmationService) { 
    if(Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios'){
      this.isIos = true
      this.isNative=true
    }else{
      this.isNative=false
    }
    this.screen_width = screen.width
    if(this.screen_width < 640){
      this.respwidth = {
        width: '85vw'
      }
    }
    else{
      this.respwidth = {
        width: '35vw'
      }
    }
  }

  showLoader(){
    this.loader=true
  }

  stopLoader(){
    this.loader=false
  }

  carbonToJs(dateCarbon){
      let months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
      let date = new Date(dateCarbon)
      return `${months[+date.getMonth()]} ${date.getDate()} ${date.getFullYear()}, ${date.toLocaleTimeString()}`
  }

  checkName(e, allowNumbers, maxLength){
    // //console.log(e.which)
    if(e.target.value.length == 0 && e.which==32)
      return false
    else if(e.target.value.length>maxLength && !(e.which == 8))
      return false
    else if(!((e.which>=65 && e.which<=90) || e.which == 8 || e.which == 37 || e.which == 39 || e.which == 35 || e.which == 36 || e.which == 32 || e.which == 46 || e.which == 9))  
      return false
  }

  checkNumber(e, maxLength){
    //console.log(e.which)
    if(e.target.value.length == 0 && e.which == 48)
      return false
    if(!(e.which >= 48 && e.which<=57 || e.which == 8))
      return false 
    else if((e.target.value.length>=maxLength && !(e.which == 8)))
      return false
  }

  getOffers(){
    return this.http.get(`${environment.api_link}/api/promotion`)
  }
  checkMaxLength(e, length){
    if(e.target.value.length>=length && !(e.which == 8))
      return false
  }
  iosComingSoon(){
    this.visibleIos = true

  setTimeout(() => {
    this.visibleIos = false
  }, 2500);
  }
  showDropdown(id){
    if(id=='sourceDrop')
      document.querySelector(`#destDrop .dropdown-content`).classList.remove('d-block')
    // else if(id == 'destDrop')
    //   document.querySelector(`#sourceDrop .dropdown-content`).classList.remove('d-block')
    document.querySelector(`#${id} .dropdown-content`).classList.toggle('d-block')
    if((document.querySelector(`#destDrop`).getBoundingClientRect().bottom )<0){
      window.scrollTo(0, 0)
    }
  }
}